// extracted by mini-css-extract-plugin
export default {"panel":"Popover_panel__F2lUe","hvPop":"Popover_hvPop__+Z231"};